import { api } from '@/lib/api/client';
import type { GetNotificationsParams, Notification, NotificationCount } from '@shared/types/entities';

import { type PaginatedResponse, buildQuery } from './types';

export async function getNotificationCount(): Promise<NotificationCount> {
  return api.get('/notifications/count');
}

export async function getNotifications(params?: GetNotificationsParams): Promise<PaginatedResponse<Notification>> {
  return api.get(`/notifications${buildQuery(params as Record<string, unknown>)}`);
}

export async function markNotificationRead(id: number): Promise<void> {
  return api.patch(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  return api.patch('/notifications/read-all');
}

export async function deleteNotification(id: number): Promise<void> {
  return api.delete(`/notifications/${id}`);
}
